import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import App from './App.tsx'
import { msalInstance } from './auth/msalInstance'
import '../src/css/app.scss'
import IdleLogout from './auth/IdleLogout'

// msalInstance is a singleton that handles redirect + callbacks in auth/msalInstance.ts

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <MsalProvider instance={msalInstance}>
            <IdleLogout timeoutMinutes={Number(import.meta.env.VITE_IDLE_TIMEOUT_MINUTES) || 15} />
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </MsalProvider>
    </StrictMode>,
)